<template>
    <div id="Globalinvitetip">
        <el-dialog
            title="邀请通知"
            :visible.sync="dialogVisible"
            :width="ismobile?'90%':'500px'"
            :close-on-click-modal="false"
            @closed="dialogclosed">
            <div 
            class="dialog-wraper" 
            v-loading="dialogloading"
            element-loading-text="请求中...">
                <div class="company-content">
                    <span>管理员邀请您加入</span>
                    <span class="namecolor">【{{dialogconent}}】</span>
                </div>
                <div style="text-align:center">
                    <el-button @click="confirmMessage" size="medium">拒 绝</el-button>
                    <el-button type="primary" size="medium"  @click="EditBackLog('agree')" style="margin-left:15px" :disabled="isbtndis">同 意</el-button>
                </div>
                
                <div class="dialog-tip">
                    <span>提示：此邀请通知也可在</span>
                    <span class="message-center" v-if="!ismobile" @click="gobacklogListpage">【消息中心】</span>
                    <span class="message-center" v-else @click="gobacklogListpage">【我的事项】</span>
                    <span>中查看处理</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
GetBackLogWithInviteRecordApi,
EditBackLogApi} from '@/js/sprint5meetingAndMessage.js'
import {mydebounce} from '@/js/common.js'
import router from '@/router/index.js'
    export default {
        data(){
            return{
                ismobile:false,
                dialogVisible:false,
                BacklogArr:[],//代办事项列表
                BacklogLength:0,//当前要展示的待办事项数组项，从大到小,默认是0
                currentBacklogobj:{},//当前需要展示的具体的代办事项对象
                dialogconent:'',//要展示的内容
                dialogloading:false,
                isbtndis:false,
            }
        },
        watch:{
            BacklogLength(newval,oldval){
                this.handleLengthchange(newval,oldval)
            }
        },
        created(){
            if(window.localStorage.getItem('logined')){
                this.GetBackLogWithInviteRecord()
            }
        },
        mounted() {
            if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                this.ismobile=true;
            }else{
                this.ismobile=false;
            }
        },
        methods:{
            destorydialog(){
                this.dialogVisible=false
                this.$emit('globalDialogClose')
            },
            gobacklogListpage(){
                
                router.replace({
                    name:this.ismobile?'NVH5backlogDetail':'backlogDetail',
                    query:{
                    backLogId:this.currentBacklogobj.id
                    }
                })
                this.destorydialog()//检查到不需要通知，销毁该全局组件
                // this.$router.push({
                //     name:'backlogDetail',
                //     query:{
                //     backLogId:this.currentBacklogobj.id
                //     }
                // })
            },
            confirmMessage(){
                let that=this;
                this.$confirm(`您确认拒绝加入【${this.dialogconent}】吗`, '提示信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass: 'message-logout'
                }).then(() => {
                    that.EditBackLog('refused')
                }).catch(() => {  
            });
            },
            EditBackLog(type){
                let that=this;
                let passportToken=window.localStorage.getItem('passportToken')
                let passportTokenModify=passportToken.split('Bearer ')[1];
                let reqdata={
                    id:this.currentBacklogobj.id,
                    backLogStatus:1,
                    passportToken:passportTokenModify
                }
                if(type=='refused'){
                    reqdata.isPass=false
                }else if(type=='agree'){
                    reqdata.isPass=true
                }
                console.log(reqdata)
                this.isbtndis=true
                this.dialogloading=true
                EditBackLogApi(reqdata)
                .then(res=>{
                    this.isbtndis=false
                    this.dialogloading=false
                    if(res.status===200 && res.data.error_code===0){
                    this.dialogVisible=false
                    this.$message.success('操作成功！')
                    if(type=='agree'){//同意操作，将所有的数组该企业没有同意的字段都置为true，从此本次弹窗不再弹出该企业的邀请。
                        this.BacklogArr.forEach(item=>{
                            if(this.currentBacklogobj.enterpriseName==item.enterpriseName && this.currentBacklogobj.certificatationStatus==item.certificatationStatus){
                                item.ishasAgree=true
                            }
                        })
                    }
                    }else{
                    this.$message.error(res.data.error_msg)
                    }
                })  
                .catch(err=>{
                    this.isbtndis=false
                    this.dialogloading=false
                    if(err.data && err.data.errorMessages){
                        that.$message.error(err.data.errorMessages[0]);
                    }else if(err.data){
                        that.$message.error(err.data);
                    }
                })
            },
            GetBackLogWithInviteRecord(){//获取个人代办事项，不包括已处理的和已拒绝的
                GetBackLogWithInviteRecordApi()
                .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    this.BacklogArr=[];
                    this.BacklogArr=res.data.data;
                    //this.BacklogLength=this.BacklogArr.length 
                    this.BacklogArr.map(item=>{//添加属性，默认标识这些通知还没有被同意。
                        return this.$set(item,'ishasAgree',false)
                    })
                    if(this.BacklogArr.length){//当前有需要关注的通知
                        this.BacklogLength=1//将通知的编号职1，标识通知数组第一条消息,并出发watch事件
                        this.currentBacklogobj=this.BacklogArr[this.BacklogLength-1]//当前通知数组中的第一条通知
                    }else{
                        this.destorydialog()//检查到不需要通知，销毁该全局组件
                    }
                    
                }else{
                    this.$message.error(res.data.error_msg)
                }
                })
                .catch(err=>{
                    this.commonerr(err)
                })  
            },
            commonerr(err){
                let that=this;
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            },
            handleLengthchange(newval,oldval){
                if(newval==this.BacklogArr.length+1){//所有事项条数已经展示完成
                    this.destorydialog()//该组件全局销毁
                    return
                }
                if(this.currentBacklogobj.ishasAgree===false){//需要展示该条通知
                    this.dialogconent=this.currentBacklogobj.enterpriseName
                    this.dialogVisible=true
                    }else{
                    this.BacklogLength++
                }
            },
            dialogclosed(){
                this.BacklogLength++
                this.currentBacklogobj=this.BacklogArr[this.BacklogLength-1]
            },

        }
    }
</script>

<style lang="scss" scoped>
    #Globalinvitetip{
        /deep/ .el-dialog{
            border-radius: 2px;
            .el-dialog__header{
                background: #0069e0;
                text-align: left;
                padding: 15px 20px;
            .el-dialog__title{
                font-family: MicrosoftYaHei;
                font-size: 16px;
                color: #FFFFFF;
                font-weight: 400;
            }
            .el-dialog__close{
                    color: #fff;
                }
            }
            .el-dialog__body{
                padding: 10px 20px 20px 20px;
            }
            .dialog-wraper{
                padding-top:70px;
                .company-content{
                line-height: 22px;
                padding-bottom:60px;
                text-align: center;
                .namecolor{
                    color: #333;
                }
                }
                .dialog-tip{
                    text-align: center;
                margin-top: 30px;
                padding-bottom: 40px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #666666;
                .message-center{
                    color: #0069e0;
                    cursor: pointer;
                }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/globalDialog/Globalinvitetip.vue